import { IconMenu2 } from '@tabler/icons-react';
import React, { useState } from 'react';
import SideMenu from '../components/SideMenu/SideMenu';
import { PROFILE } from '../statics/localStorage';
import { Link } from 'react-router-dom';

const Layout = ({ children }) => {
    const [isMobile] = useState(window.innerWidth < 992 ? true : false);
    const [isOpen, setIsOpen] = useState(window.innerWidth > 992 ? true : false);
    const adminProfile = PROFILE();
    const sidebarToggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <div className="main-container flex relative">

            <SideMenu isOpen={isOpen} />

            {isMobile && <div className='bg-slate-950 absolute h-screen z-[1] opacity-70'
                style={{ width: isOpen ? "100vw" : '0px', transition: 'all 0.1s ease-in-out' }}
                onClick={() => setIsOpen(false)} />}

            <div className='content-body h-100vh'
                style={{ width: (isOpen && !isMobile) ? 'calc(100vw - 200px)' : '100vw', marginLeft: (isOpen && !isMobile) ? '200px' : '0px', transition: 'all 0.3s ease-in-out' }}>

                <nav className='bg-primary-background px-6 fixed flex top-0 py-[16px] text-white justify-between z-[2]'
                    style={{ width: (isOpen && !isMobile) ? 'calc(100vw - 200px)' : '100vw', marginLeft: (isMobile && isOpen) ? '200px' : '0px', transition: 'all 0.3s ease-in-out' }}>
                    <button onClick={() => sidebarToggle()}>
                        <IconMenu2 />
                    </button>
                    <Link to={'/admin-profile'}>
                        <div className='flex items-center gap-2'>
                            <img src={adminProfile?.profilePic} alt={`${adminProfile?.username}-profile-pic`} className='h-8 aspect-square rounded-full object-cover' />
                            <p className='fw-bold capitalize'>{adminProfile?.username}</p>
                        </div>
                    </Link>
                </nav>

                <div className="content pt-[80px] !pb-5 h-screen !px-4 overflow-y-auto overflow-x-hidden" style={{ transition: 'all 0.3s ease-in-out' }}>
                    {children}
                </div>

            </div>

        </div>
    )
}

export default Layout